import { CombinedGraphQLErrors } from '@apollo/client/errors'

export type GlobalRecoveryKind = 'stale-client' | 'unauthenticated'
export const GLOBAL_RECOVERY_EVENT = 'mbscan:global-recovery'

// 古いバンドルの検知（リロード促進）と BugSnag の severity 判定の両方で使うため、
// 片方だけ直す事故を防ぐ目的でここに置いて共有する
export const GRAPHQL_VALIDATION_FAILED_CODE = 'GRAPHQL_VALIDATION_FAILED'

export function getGlobalRecoveryKind(error: Error): GlobalRecoveryKind | null {
  if (!CombinedGraphQLErrors.is(error)) {
    return null
  }
  const codes = error.errors.map(({ extensions }) => extensions?.code)
  if (codes.some((code) => code === 'UNAUTHENTICATED')) {
    return 'unauthenticated'
  }
  return codes.some((code) => code === GRAPHQL_VALIDATION_FAILED_CODE) ? 'stale-client' : null
}

export function dispatchGlobalRecovery(kind: GlobalRecoveryKind): void {
  window.dispatchEvent(new Event(`${GLOBAL_RECOVERY_EVENT}:${kind}`))
}
